<template>
  <div :class="distinguish == 1 ? 'cola-list' : 'cola-list1'">
    <!-- 1 -->
    <div class="cola-list-i" v-for="(item, i) in list" :key="i">
      <div class="cola-list-img">
        <img
          :src="nubre == i ? list1[i] : nubre == 8 ? list1[i] : list[i].imgag"
          @click="avice(i)"
          @mouseover="touch(i)"
          @mouseleave="touch1()"
          alt
        />
      </div>
      <div class="cola-list-acvie">
        <div class="cola-list-acvie-g"></div>
        <div
          :style="{
            backgroundImage:
              nubre == i
                ? `url(${imgag})`
                : nubre == 8
                  ? `url(${imgag})`
                  : `url(${imgag1})`,
          }"
          :class="setat == i ? 'cola-list-acvie-name1' : 'cola-list-acvie-name'"
        >{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      nubre: null,
      setat: null,
      distinguish: 1,
      list: [
        { imgag: require("../../../assets/sb/wscgq.png"), name: "瓦斯传感器" },
        {
          imgag: require("../../../assets/sb/fcldcgq.png"),
          name: "粉尘浓度传感器",
        },
        { imgag: require("../../../assets/sb/cocgq.png"), name: "CO传感器" },
        { imgag: require("../../../assets/sb/fscgq.png"), name: "风速传感器" },
        { imgag: require("../../../assets/sb/ducgq.png"), name: "温度传感器" },
        { imgag: require("../../../assets/sb/spjk.png"), name: "视频监控" },
        { imgag: require("../../../assets/sb/ry.png"), name: "人员" },
        { imgag: require("../../../assets/sb/c.png"), name: "车辆" },
        { imgag: require("../../../assets/sb/la.png"), name: "全部设备" },
      ],
      list1: [
        require("../../../assets/sb/wscgq0.png"),
        require("../../../assets/sb/fcldcgq1.png"),
        require("../../../assets/sb/COcgq2.png"),
        require("../../../assets/sb/fscgq3.png"),
        require("../../../assets/sb/wdcgq4.png"),
        require("../../../assets/sb/spjk5.png"),
        require("../../../assets/sb/ry6.png"),
        require("../../../assets/sb/cl7.png"),
        require("../../../assets/sb/qbsb8.png"),
      ],
      imgag: require("../../../assets/sb/back.png"),
      imgag1: require("../../../assets/sb/back1.png"),
    };
  },
  mounted() {
    // zdy 传入
    this.emit.$on("distinguish", (e) => {
      this.distinguish = e;
    });
  },
  methods: {
    avice(i) {
      if (this.nubre == i) {
        this.nubre = 100;
        return;
      }
      this.nubre = i;
    },
    touch(i) {
      this.setat = i;
    },
    touch1() {
      this.setat = 100;
    },
  },
};
</script>
<style lang="less" scoped>
.cola-list {
  width: 100%;
  height: 100%;
  background-image: url("../../../assets/arc.png");
  background-size: 40% auto;
  background-repeat: no-repeat;
  background-position-x: 1vw;
  transition: all 1s;
  transform: translateX(5%);
  position: absolute;
}

.cola-list1 {
  width: 100%;
  height: 100%;
  position: absolute;
  background-image: url("../../../assets/arc.png");
  background-size: 40% auto;
  background-repeat: no-repeat;
  transition: all 1s;
  background-position-x: 1vw;
  transform: translateX(-115%);
}
.cola-list > div:first-child {
  position: absolute;
  left: 1.6vw;
  top: 2vh;
  width: 9vw;
  height: 4vh;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .keyframesA();
}
.cola-list > div:nth-child(2) {
  position: absolute;
  left: 0.5vw;
  top: 8vh;
  width: 9vw;
  height: 4vh;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .keyframesA(@delay:0.8s);
}
.cola-list > div:nth-child(3) {
  position: absolute;
  left: 0vw;
  top: 14vh;
  width: 9vw;
  height: 4vh;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .keyframesA(@delay:1s);
}
.cola-list > div:nth-child(4) {
  position: absolute;
  left: -0.2vw;
  top: 20vh;
  width: 9vw;
  height: 4vh;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .keyframesA(@delay:1.2s);
}
.cola-list > div:nth-child(5) {
  position: absolute;
  left: -0.4vw;
  top: 26vh;
  width: 9vw;
  height: 4vh;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .keyframesA(@delay:1.4s);
}
.cola-list > div:nth-child(6) {
  position: absolute;
  left: -0.3vw;
  top: 32vh;
  width: 9vw;
  height: 4vh;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .keyframesA(@delay:1.6s);
}
.cola-list > div:nth-child(7) {
  position: absolute;
  left: -0.1vw;
  top: 38vh;
  width: 9vw;
  height: 4vh;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .keyframesA(@delay:1.8s);
}
.cola-list > div:nth-child(8) {
  position: absolute;
  left: 0.9vw;
  top: 44vh;
  width: 9vw;
  height: 4vh;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .keyframesA(@delay:2s);
}
.cola-list > div:nth-child(9) {
  position: absolute;
  left: 3vw;
  top: 50vh;
  width: 9vw;
  height: 4vh;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .keyframesA(@delay:2.2s);
}

.cola-list1 > div:first-child {
  position: absolute;
  left: 1.6vw;
  top: 2vh;
  width: 9vw;
  height: 4vh;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.cola-list1 > div:nth-child(2) {
  position: absolute;
  left: 0.5vw;
  top: 8vh;
  width: 9vw;
  height: 4vh;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.cola-list1 > div:nth-child(3) {
  position: absolute;
  left: 0vw;
  top: 14vh;
  width: 9vw;
  height: 4vh;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.cola-list1 > div:nth-child(4) {
  position: absolute;
  left: -0.2vw;
  top: 20vh;
  width: 9vw;
  height: 4vh;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.cola-list1 > div:nth-child(5) {
  position: absolute;
  left: -0.4vw;
  top: 26vh;
  width: 9vw;
  height: 4vh;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.cola-list1 > div:nth-child(6) {
  position: absolute;
  left: -0.3vw;
  top: 32vh;
  width: 9vw;
  height: 4vh;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.cola-list1 > div:nth-child(7) {
  position: absolute;
  left: -0.1vw;
  top: 38vh;
  width: 9vw;
  height: 4vh;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.cola-list1 > div:nth-child(8) {
  position: absolute;
  left: 0.9vw;
  top: 44vh;
  width: 9vw;
  height: 4vh;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.cola-list1 > div:nth-child(9) {
  position: absolute;
  left: 3vw;
  top: 50vh;
  width: 9vw;
  height: 4vh;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.cola-list-acvie {
  width: 60%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  .cola-list-acvie-g {
    width: 100%;
    height: 40%;
    padding: 0 1vw 0 0;
    text-align: right;
    img {
      width: 15%;
      height: auto;
    }
  }
  .cola-list-acvie-name {
    display: flex;
    max-height: 60%;
    align-items: center;
    padding: 0.2vh 0vw 0.2vh 0.5vw;
    color: #fff;
    font-size: 0.5vw;
    letter-spacing: 0.2vw;
    background-repeat: no-repeat;
    white-space: nowrap;
    transition: opacity 0.5s;
    opacity: 0;
  }
  .cola-list-acvie-name1 {
    display: flex;
    max-height: 60%;
    align-items: center;
    padding: 0.2vh 0vw 0.2vh 0.5vw;
    color: #fff;
    background-repeat: no-repeat;
    font-size: 0.5vw;
    letter-spacing: 0.2vw;
    white-space: nowrap;
    transition: opacity 0.5s;
    opacity: 100;
  }
}
.cola-list-img {
  width: 30%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 100%;
    height: auto;
    cursor: pointer;
  }
}
</style>